import { render, staticRenderFns } from "./HomeDispatcher.vue?vue&type=template&id=38ea4134"
import script from "./HomeDispatcher.vue?vue&type=script&lang=js"
export * from "./HomeDispatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports